
import 'pages/payments/payments-list.tag'
import 'pages/payments/payments-edit.tag'
riot.tag2('payments', '  <div class="column" if="{!notFound}">\n    <payments-list if="{!edit}"></payments-list>\n    <payments-edit if="{edit}"></payments-edit>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();

self.edit = false;

route('/payments', function () {
    self.notFound = false;
    self.edit = false;
    self.update();
});

route('/payments/new', function () {
    observable.trigger('payments-new');
    self.notFound = false;
    self.edit = true;
    self.update();
});

route('/payments/([0-9]+)', function (id) {
    observable.trigger('payments-edit', id);
    self.notFound = false;
    self.edit = true;
    self.update();
});

route('/payments..', function () {
    self.notFound = true;
    self.update();
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/payments/payments.tag